<template>
    <b-card class="tabs-component">
        <b-tabs pills vertical class="mlateral">
            <b-tab v-if="modulesInfo.main.hasHidro" class="tabs-component-tabs" active>
                <template slot="title">
                    <b-col>
                        <icon name="burn"></icon>
                        <!-- electrolysis hidrolysis? -->
                        <p style="margin-bottom:0;">{{ (modulesInfo.hidro.is_electrolysis) ? $t("messages.electro") :
                            $t("messages.hidro") }}</p>
                    </b-col>
                </template>
                <hidro :pool-id="modulesInfo" v-on:onSave="onSave"> </hidro>
            </b-tab>
            <b-tab class="tabs-component-tabs">
                <template slot="title">
                    <b-col>
                        <icon name="sliders-h"></icon>
                        <!-- set points -->
                        <p style="margin-bottom:0;">{{ $t("messages.setPoints") }}</p>
                    </b-col>
                </template>
                <consigns :pool-id="modulesInfo" v-on:onSave="onSave"> </consigns>
            </b-tab>

            <b-tab v-if="!modulesInfo.main.hideFiltration" class="tabs-component-tabs">
                <template slot="title">
                    <b-col>
                        <icon name="bolt"></icon>
                        <!-- filtration -->
                        <p style="margin-bottom:0;">{{ $t("messages.filtration") }}</p>
                    </b-col>
                </template>
                <filtration :pool-id="modulesInfo" v-on:onSave="onSave"> </filtration>
            </b-tab>

            <b-tab v-if="!modulesInfo.main.hideLighting" class="tabs-component-tabs">
                <template slot="title">
                    <b-col>
                        <icon name="lightbulb"></icon>
                        <!-- lighting -->
                        <p style="margin-bottom:0;">{{ $t("messages.lighting") }}</p>
                    </b-col>
                </template>
                <lighting :pool-id="modulesInfo" v-on:onSave="onSave"> </lighting>
            </b-tab>
            <b-tab v-if="modulesInfo.main.hasIO" class="tabs-component-tabs">
                <template slot="title">
                    <b-col>
                        <icon name="tint"></icon>
                        <p style="margin-bottom:0;">{{ $t("messages.ionization") }}</p>
                    </b-col>
                </template>
                <ionization :pool-id="modulesInfo" v-on:onSave="onSave"> </ionization>
            </b-tab>
            <b-tab v-if="modulesInfo.main.hasUV" class="tabs-component-tabs">
                <template slot="title">
                    <b-col>
                        <img src="../assets/uv-icon.png" style="height:25px" />
                        <p style="margin-bottom:0;">{{ $t("messages.uv") }}</p>
                    </b-col>
                </template>
                <ultraviolet :pool-id="modulesInfo" v-on:onSave="onSave"> </ultraviolet>
            </b-tab>

            <b-tab v-if="!modulesInfo.main.hideRelays" class="tabs-component-tabs">
                <template slot="title">
                    <b-col>
                        <icon name="cog"></icon>
                        <!-- aux relayx -->
                        <p style="margin-bottom:0;">{{ $t("messages.auxRelays") }}</p>
                    </b-col>
                </template>
                <relays :pool-id="modulesInfo" :relays-info="modulesInfo.relays" v-on:onSave="onSave"> </relays>
            </b-tab>
        </b-tabs>
        <modal name="login-box" transition="nice-modal-fade" :min-width="200" :min-height="250" :pivot-y="0.5"
            :adaptive="true" :scrollable="true" :reset="true" width="30%" height="auto" :clickToClose="false">
            <div class="modal-detail-content">
                <b-row>
                    <b-btn @click="$modal.hide('login-box');" class="closePopup">
                        <icon name="times-circle"></icon>
                    </b-btn>
                </b-row>
                <b-col>
                    <login-box v-on:onLogin="onLogin"></login-box>
                </b-col>
            </div>
        </modal>
    </b-card>
</template>

<script>
import {
    mapState
} from 'vuex';
import Lighting from './Lighting.vue'
import Ionization from './Ionization.vue'
import Ultraviolet from './Ultraviolet.vue'
import Hidro from './Hidro.vue'
import Filtration from './Filtration.vue'
import Relays from './Relays.vue'
import Consigns from './Consigns.vue'
import LoginBox from './utils/LoginBox.vue'

const fb = require('../firebaseConfig.js')
const diff = require('deep-diff').diff;

export default {
    name: 'Config',
    components: {
        Lighting,
        Ionization,
        Ultraviolet,
        Hidro,
        Filtration,
        Relays,
        Consigns,
        LoginBox
    },
    props: {
        modulesInfo: {}
    },
    data() {
        return {
            localTime: this.$moment(this.modulesInfo.main.localTime).format(),
        }
    },
    computed: {
        ...mapState(['currentUser']),
    },
    methods: {
        onLogin(login) {
            var credential = fb.auth.EmailAuthProvider.credential(
                this.currentUser.email,
                login.password
            );
            this.currentUser.reauthenticateAndRetrieveDataWithCredential(credential).then(() => {
                // reautenthicated user
                console.log('Re-authenticated user');
                this.$modal.hide('login-box');

            }).catch(function (error) {
                console.log(error);
            });
        },

        onSave(cached, pool, type = null, numReel = null) {
            var changes = diff(cached, pool);
            // connecting to the pool, sending data
            var _json;
            switch (type) {
                case 'main':
                    _json = pool.main;
                    break;
                case 'filtration':
                   if(changes[0].path[0] == 'backwash'){
                    _json = {'backwash':pool.backwash};
                   }else{
                    _json = {'filtration':pool.filtration};
                   }
                    break;
                case 'modules':
                    const  {ph, rx, cd, cl} = pool.modules;
                    _json = {'modules_web':{ph, rx, cd, cl} };
                    break;
                case 'hidro':
                    _json = {'hidro':pool.hidro};
                    break;
                case 'light':
                    _json = {'light':pool.light};
                    break;
                case 'relays':
                    _json = {'relays':{['relay'+numReel]:pool.relays['relay'+numReel]}};
                    break;
                case 'io':
                    const  {io} = pool.modules;
                    _json = {'modules_web':{ io} };
                    break;
                case 'uv':
                    const  {uv} = pool.modules;
                    _json = {'modules_web':{ uv} };
                    break;
            }

            if(pool.isDemo && pool.isDemo == true){
                this.$snotify.async(this.$t("messages.alertConnectingPool"), this.$t("messages.alertSendingData"), () => new Promise((resolve, reject) => {
                    fb.poolsDemoCollection.doc('8PUMEXYSUCQZSTLLODDU').update(pool).then(es => {
                        resolve({
                        title: 'Info',
                        body: this.$t("messages.configRecieved"),
                        config: {
                            timeout: 3000,
                            closeOnClick: true
                            }
                        }) 
                    }, error => {
                    console.log('error');
                    reject({
                        title: 'Info',
                        body: this.$t("messages.poolNotConnected"),
                        config: {
                            timeout: 3000,
                            closeOnClick: true
                        }
                    })
                });        
                }))
            }else{
                this.$snotify.async(this.$t("messages.alertConnectingPool"), this.$t("messages.alertSendingData"), () => new Promise((resolve, reject) => {
                    this.$store.dispatch('sendPoolCommandAWS', {
                        'wifi': pool.wifi,
                        'id': pool.id,
                        'changes': JSON.stringify(_json),
                        'pool': pool
                    }).then(response => {
                        resolve({
                            //    info, the pool has recieved the new configuration
                            title: 'Info',
                            body: this.$t("messages.configRecieved"),
                            config: {
                                timeout: 3000,
                                closeOnClick: true
                            }
                        })
                    }, error => {
                        console.log('error');
                        reject({
                            // the pool is not connected
                            title: 'Info',
                            body: this.$t("messages.poolNotConnected"),
                            config: {
                                timeout: 3000,
                                closeOnClick: true
                            }
                        })
                    });
                }))
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Config.vue